export const THEME_STORAGE_KEY = 'promea-theme';

export type ThemeMode = 'light' | 'dark';

/** Pour l’instant le site reste toujours en mode sombre. */
export const FORCE_DARK_THEME = true;

export function getStoredTheme(): ThemeMode {
  if (FORCE_DARK_THEME) return 'dark';
  if (typeof window === 'undefined') return 'dark';

  const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
  return stored === 'light' || stored === 'dark' ? stored : 'dark';
}

export function applyTheme(theme: ThemeMode): void {
  const resolved = FORCE_DARK_THEME ? 'dark' : theme;
  const root = document.documentElement;
  root.setAttribute('data-theme', resolved);
  root.classList.toggle('dark', resolved === 'dark');

  const metaTheme = document.querySelector('meta[name="theme-color"]');
  if (metaTheme) {
    metaTheme.setAttribute('content', resolved === 'dark' ? '#2B2926' : '#FFFFFF');
  }
}

export function initTheme(): ThemeMode {
  const theme = getStoredTheme();
  applyTheme(theme);
  return theme;
}
